// third-party
import { combineReducers } from 'redux';

// project import
import menu from './menu';
import pages from './pages';
import pagesSse from './pagesSse';
import mission from './mission';
import flightIndicators from './flight-indicators';
// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
    menu,
    pages,
    pagesSse,
    mission,
    flightIndicators,
});

export default reducers;
